import styled from 'styled-components';

export const EnquiryFormInput = styled.div`
  margin-bottom: 15px;
`;

export const EnquiryFormButtonContainer = styled.div`
  max-width: 380px;
  margin: 40px auto;
`;
